import Column from '../../core/components/box/column';
import SizedBox from '../../core/components/box/sizedBox';
import LXInput from '../../core/texts/lxInput';
import { LXbody, LXh2 } from '../../core/texts/lxText';
import { ReactComponent as KlabLogo } from '../../../assets/logos/klabLogo.svg';
import { useTheme } from 'styled-components';
import LXLargeButton from '../../core/components/buttons/lxLargeButton';
import useForgetPageController from '../../../1_application/auth/forgetPageController';
import { useEffect } from 'react';

const ForgetForm: React.FC = () => {
  const theme = useTheme();
  const f = useForgetPageController();

  useEffect(() => {
    const handleEnter = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && f.buttonRef.current)
        f.buttonRef.current.click();
    };
    window.addEventListener('keydown', handleEnter);
    return () => window.removeEventListener('keydown', handleEnter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Column>
      <KlabLogo width={107} height={40}></KlabLogo>
      <SizedBox height={20}></SizedBox>
      <LXh2>{theme.texts.forgotPassword}</LXh2>
      <SizedBox height={40}></SizedBox>
      <LXbody>{theme.texts.email}</LXbody>
      <SizedBox height={8}></SizedBox>
      <LXInput
        tabIndex={1}
        type="email"
        onChange={f.handleInputChange}
        width={320}
        placeholder={theme.texts.enterEmailAddress}
      ></LXInput>
      <SizedBox height={40}></SizedBox>
      <LXLargeButton
        refProp={f.buttonRef}
        tabIndex={2}
        onClick={f.onSendRequest()}
      >
        {theme.texts.send}
      </LXLargeButton>
      <SizedBox height={8}></SizedBox>
      <LXLargeButton tabIndex={3} kind={'secondary'} onClick={f.goToLogin}>
        {theme.texts.cancel}
      </LXLargeButton>
    </Column>
  );
};

export default ForgetForm;
